import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
    link: {},
    create: {},
    exchange: {},
    error: null,
    loading: true,
};


export const postCreateIncome = createAsyncThunk(
    "income/postCreateIncome",
    async ({ data }, thunkAPI) => {
        const headers = {
            "api-version": "v1",
            "Ocp-Apim-Subscription-Key": "08ed34ad38d34939ba9888480eba417d",
        };

        let url = `${process.env.REACT_APP_PALIDIN_ENDPOINT_DEV}v1/income/user/create?accessToken=${data?.token}`;
        try {
            const response = await axios.post(url, null, { headers });

            if (response?.data) {
                return {
                    status: response?.data,
                };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue({ error: error.response.data });
        }
    }
);

export const postLinkIncome = createAsyncThunk(
    "income/postLinkIncome",
    async ({ data }, thunkAPI) => {
        const headers = {
            "api-version": "v1",
            "Ocp-Apim-Subscription-Key": "08ed34ad38d34939ba9888480eba417d",
        };
        const body = {
            accessToken: data?.token,
            incomeType: data?.type,
        }
        let url = `${process.env.REACT_APP_PALIDIN_ENDPOINT_DEV}v1/income/createLink`;

        try {
            const response = await axios.post(url, body, { headers });

            if (response?.data) {
                return {
                    status: response?.data,
                };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue({ error: error.response.data });
        }
    }
);

export const postExchangeIncome = createAsyncThunk(
    "income/postExchangeIncome",
    async ({ data }, thunkAPI) => {
        const headers = {
            "api-version": "v1",
            "Ocp-Apim-Subscription-Key": "08ed34ad38d34939ba9888480eba417d",
        };

        let url = `${process.env.REACT_APP_PALIDIN_ENDPOINT_DEV}v1/item/exchange`;
        let body = {
            access_token: data?.token,
            income_type: data?.type,
            public_token: data?.public_token,
        }
        try {
            const response = await axios.post(url, body, { headers });

            if (response?.data) {
                return {
                    status: response?.data,
                };
            }
        } catch (error) {
            return thunkAPI.rejectWithValue({ error: error.response.data });
        }
    }
);

export const incomeSlice = createSlice({
    name: "Income",
    initialState,
    reducers: {
        reset: (state) => {
            return initialState;
        },
    },

    extraReducers: (builder) => {
        builder.addCase(postLinkIncome.fulfilled, (state, action) => {
            state.link = action.payload?.link;
        });
        builder.addCase(postLinkIncome.rejected, (state, action) => {
            state.link = initialState.link;
        });

        builder.addCase(postExchangeIncome.fulfilled, (state, action) => {
            state.exchange = action.payload?.exchange;
        });
        builder.addCase(postExchangeIncome.rejected, (state, action) => {
            state.exchange = initialState.exchange;
        });

        builder.addCase(postCreateIncome.fulfilled, (state, action) => {
            state.create = action.payload?.create;
        });
        builder.addCase(postCreateIncome.rejected, (state, action) => {
            state.create = initialState.create;
        });
    },
});

export const { reset } = incomeSlice.actions;
